import styled from 'styled-components';

export const OutstandingActionsComponent = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing(20)};
`;
